// When the site is embedded (e.g. on itch.io), the account pages refuse to
// load in the frame (website/middleware.py), so links and forms to them open
// in a new tab instead. Delegated, so it covers content htmx swaps in later.

const ACCOUNT_PATH_PREFIX = '/accounts/'

export const isEmbedded = window.self !== window.top

const isAccountUrl = (url) => {
    const { origin, pathname } = new URL(url, window.location.href)
    return (
        origin === window.location.origin &&
        pathname.startsWith(ACCOUNT_PATH_PREFIX)
    )
}

if (isEmbedded) {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('a[href]')
        if (link && isAccountUrl(link.href)) {
            link.target = '_blank'
            link.rel = 'noopener'
        }
    })

    document.addEventListener('submit', (event) => {
        const form = event.target
        if (isAccountUrl(form.action)) {
            form.target = '_blank'
        }
    })
}
